export default __webpack_public_path__ + "static/media/cross.cf155cc2.svg";